export const sendForm = async ({
  firstname,
  lastname,
  email,
  mobilephone,
  company,
}) => {
  const url =
    "https://forms-eu1.hsforms.com/submissions/v3/public/submit/formsnext/multipart/26786777/5c124ab5-2827-47c4-bf26-5fdde1e6ab45";
  const payload = {
    "embedAtTimestamp": "1696169118416", "formDefinitionUpdatedAt": "1696164960151", "lang": "fr", "embedType": "REGULAR", "userAgent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/116.0.0.0 Safari/537.36", "pageTitle": "Onlysales", "pageUrl": "http://localhost:8080/", "referrer": "http://localhost:8080/", "isHubSpotCmsGeneratedPage": false, "hutk": "cfd73a6d60259dbaeeb1517b232cb744", "__hstc": "181257784.cfd73a6d60259dbaeeb1517b232cb744.1688507041136.1694697774648.1694770711842.15", "formTarget": "#hbspt-form-46086dfd-da3a-4290-a5e8-64ebf03fc59a", "locale": "fr", "timestamp": 1696169137849, "originalEmbedContext": { "portalId": "26786777", "formId": "5c124ab5-2827-47c4-bf26-5fdde1e6ab45", "region": "eu1", "target": "#hbspt-form-46086dfd-da3a-4290-a5e8-64ebf03fc59a", "isBuilder": false, "isTestPage": false, "isPreview": false, "isMobileResponsive": true, "isInsideFrame": true, "shellId": 0, "pageTitle": "Onlysales", "pageUrl": "http://localhost:8080/", "referrer": "http://localhost:8080/" }, "correlationId": "46086dfd-da3a-4290-a5e8-64ebf03fc59a", "renderedFieldsIds": ["firstname", "lastname", "email", "mobilephone", "company"], "captchaStatus": "NOT_APPLICABLE", "emailResubscribeStatus": "NOT_APPLICABLE", "isInsideCrossOriginFrame": false, "source": "forms-embed-1.3812", "sourceName": "forms-embed", "sourceVersion": "1.3812", "sourceVersionMajor": "1", "sourceVersionMinor": "3812", "_debug_allPageIds": {}, "_debug_embedLogLines": [{ "clientTimestamp": 1696169119120, "level": "INFO", "message": "Retrieved pageContext values which may be overriden by the embed context: {\"pageTitle\":\"Onlysales\",\"pageUrl\":\"http://localhost:8080/\",\"referrer\":\"http://localhost:8080/\",\"userAgent\":\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/116.0.0.0 Safari/537.36\",\"isHubSpotCmsGeneratedPage\":false}" }, { "clientTimestamp": 1696169119123, "level": "INFO", "message": "Retrieved countryCode property from normalized embed definition response: \"FR\"" }]
  }

  const body = new FormData()
  body.append("firstname", firstname)
  body.append("lastname", lastname)
  body.append("email", email)
  body.append("mobilephone", mobilephone)
  body.append("company", company)
  body.append("hs_context", JSON.stringify(payload))

  const response = await fetch(url, {
    method: "POST",
    body,
  })

  const data = await response.text()

  // "accepted":false
  if(data.includes('"accepted":false')) {
    throw new Error(data)
  }

  return data
}

export default {
  sendForm,
}